module.exports = __webpack_public_path__ + "static/img/product_search.ae904b5a.png";